import Meta from '@/components/common/Meta'

import VacationLuggageStorageAndShippingPage from '@/v2/components/pages/landing-pages/vacation-luggage-storage-and-shipping-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/vacation-luggage-storage-and-shipping-page'

interface VacationLuggageStorageAndShippingPageProps {}

const Page: React.FC<VacationLuggageStorageAndShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.vacation_luggage_storage_and_shipping.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.vacation_luggage_storage_and_shipping?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.vacation_luggage_storage_and_shipping?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <VacationLuggageStorageAndShippingPage />
    </>
  )
}

export default Page
